import { PamiaChatRepository } from "@/domain/repositories";
import { PamiaChatSession } from "@/domain/entities";
import { PamiaChatDataSource } from "../datasources/pamia";

export class PamiaChatRepoImpl implements PamiaChatRepository {
  constructor(private readonly dataSource: PamiaChatDataSource) {}

  async getWebviewUrl(): Promise<PamiaChatSession> {
    return this.dataSource.getWebviewUrl();
  }
}
